// extracted by mini-css-extract-plugin
export default {"GraphHoverInfo":"styles_GraphHoverInfo__NyGvr","title":"styles_title__5VVz3","value":"styles_value__3Z4oL"};